<template>
  <div class="proQRCodeDialog" @click="((event)=>onClose(event))" id="proQRCodeDialog">
    <div class="pro-qrcode-dialog" @click="((event)=>onItemClick(event))">
      <span class="pro-qrcode-dialog-title">{{dialogType == 6 ? $t('pro_pay_wechat_use_tips') : $t('pro_pay_alipay_use_tips')}}</span>
      <div class="pro-qrcode-dialog-content">
        <img :src="dialogType == 6 ? wxPay : zfbPay" :alt="$t(dialogType == 6 ? 'pro_pay_wechat' : 'pro_pay_alipay')" class="pro-qrcode-dialog-content-img">
        <span class="pro-qrcode-dialog-pay-title" v-if="payData && payData.price">￥{{payData && payData.price}}</span>
      </div>
      <div class="qrcode-box" v-if="dialogType == 6">
        <img :src="qrCodeData" :alt="$t('enterprise_ui_payment_qr_code')" class="qrIcon">
      </div>
      <div class="qrcode-box" v-if="dialogType == 5">
        <iframe ref="iframeRef" :src="payData && payData.url" frameborder="0" :key="iframeKey" allow="payment"
        @load="onIframeLoad" @error="onIframeError" class="pro-qrcode-dialog-content-iframe" sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
        allowpaymentrequest scrolling="no">
          
        </iframe>
      </div>
      <span class="pro-qrcode-dialog-tips">{{dialogType == 6 ? $t('pro_pay_wechat_open_tips') : $t('pro_pay_alipay_open_tips')}}</span>
      <p v-if="paymentNotice" class="pro-qrcode-dialog-notice" role="status">{{ $t(paymentNotice) }}</p>
      <i class="iconfont icon-icon_close" @click="((event)=>onClose(event))"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import useUserStore from "@/store/modules/user";
import useProStore from "@/store/modules/pro";
import useBasicStore from "~/store/modules/basic";
// import {getRequestUserTradeByOrder, getRequestAccountUserInfo, getRequestConfig} from "@/net/upload"
import {storeToRefs} from "pinia";
import {defineEmits, defineExpose, ref, watch, onMounted , onUnmounted, nextTick} from "vue";
import Toast from "@/utils/toast";
import {useI18n} from "vue-i18n";
import {useRouter} from "vue-router";
import wxPay from "@/assets/images/pay/icon_weixin.png"
import zfbPay from "@/assets/images/pay/icon_zfb.png"
import qrcode from 'qrcode'
import eventBus from 'vue3-eventbus'
import ProServer from '~/services/ProServer'
import { getEnterpriseOrderState } from '~/utils/enterprisePayment'
import { useEnterpriseBalanceAlert } from '~/composables/useEnterpriseBalanceAlert'

let qrCodeData = ref("")

const { t, locale } = useI18n()
const userStore = useUserStore();
const { userInfo, token } = storeToRefs(userStore);
const proStore = useProStore();
const { proConfig } = storeToRefs(proStore);
const basicStore = useBasicStore();
const { languages} = storeToRefs(basicStore);

const router = useRouter()
const timeId = ref();
const iframeKey = ref(0)
const iframeRef = ref()
const paymentNotice = ref('')
const balanceAlert = useEnterpriseBalanceAlert()
let closed = false
let pollCount = 0

const props = defineProps({
  dialogType: {
    type: Number,
    default: 5
  },
  payData: {
    type: Object,
    default: () => {}
  },
})

let call = defineEmits(["onClose", "payment-result"])
defineExpose({ onShow })

function onItemClick(e :Event) {
  e.stopPropagation()
}

function onClose(e :Event) {
  closed = true
  call("onClose")
  e.stopPropagation()
  clearTimer()
}

// 5 支付宝 6 微信
function onShow(type :number, data: {url: string, price: number, orderNo: string}) {
  console.log("onShow")
  // dialogType.value = type
  // payData.value = data
  if(type == 6) {
    let opts = {
      errorCorrectionLevel: 'H',
      type: 'image/jpeg',
      quality: 0.3,
      margin: 2,
    }
    qrcode.toDataURL(data.url, opts, (error, url) => {
      if (error) {

      }else {
        qrCodeData.value = url
      }
    })
  }else {
    qrCodeData.value = data.url
    setTimeout(()=>{
      refreshIframe()
    },500)
  }

  // if (timeId.value) {
  //   clearInterval(timeId.value)
  // }
  // timeId.value = setInterval(()=>{
  //   getPayStatus()
  // },2000)

  // getPayStatus()
}

async function getPayStatus() {
  if (closed || !props.payData.orderNo) return
  pollCount += 1
  try {
    const response = await ProServer.getTradeOrder(props.payData.orderNo)
    if (closed) return
    if (response.code === '1' && response.data) {
      const state = getEnterpriseOrderState(response.data)
      if (state !== 'pending') {
        closed = true
        clearTimer()
        if (state === 'paid') {
          await Promise.allSettled([userStore.getUserInfo(), userStore.getBizTeamInfo(), balanceAlert.refresh(true)])
          eventBus.emit('paySuccess', props.dialogType)
          Toast(t('pay_success'))
        } else if (state === 'manual') {
          call('payment-result', `${t('enterprise_ui_payment_manual')} ${t('enterprise_ui_payment_order_no', { orderNo: props.payData.orderNo })}`)
        } else Toast(t('pay_fail'))
        call('onClose')
        return
      }
    }
  } catch { paymentNotice.value = 'enterprise_ui_payment_retry' }
  if (closed) return
  if (pollCount >= 100) {
    paymentNotice.value = 'enterprise_ui_payment_poll_stopped'
    return
  }
  timeId.value = setTimeout(getPayStatus, 3000)
}

const refreshIframe = async () => {
  await nextTick();
  iframeKey.value += 1; // 改变key强制重新创建iframe
};

// 刷新用户相关权益 和 配置
async function updataUserData() {
  await getConfigById()
  await getAccountUserInfo()
}

async function getAccountUserInfo(){
  // await getRequestAccountUserInfo().then((data)=> {
  //   if (data.code == "1") {
  //     userInfo.value = data.data
  //     localStorage.setItem("user", JSON.stringify(data.data))
  //   }
  // })
}

async function getConfigById(){
  // await getRequestConfig().then((data)=>{
  //   if (data.code == "1") {
  //     userStore.setConfig(data.data)
  //   }
  // }).catch(()=>{

  // })
}

function clearTimer(){
  timeId.value && clearTimeout(timeId.value)
  timeId.value = null
}

const onIframeLoad = () => {
  console.log('支付宝二维码加载完成');
};

const onIframeError = () => {
  console.log('支付宝二维码加载失败');
};

onMounted(() => {
  if(props.dialogType == 6) {
    let opts = {
      errorCorrectionLevel: 'H',
      type: 'image/jpeg',
      quality: 0.3,
      margin: 2,
    }
    qrcode.toDataURL(props.payData.url, opts, (error, url) => {
      if (error) {

      }else {
        qrCodeData.value = url
      }
    })
  }
  getPayStatus()
})

onUnmounted(() => { closed = true; clearTimer() })

</script>

<style scoped lang="scss">
.pro-qrcode-dialog-notice {
  max-width: 360px;
  color: #92400e;
  background: #fff7e6;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.6;
}

.proQRCodeDialog {
  flex-direction: column;
  width: 100%;
  // height: 100vh;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  
  // padding: env(safe-area-inset-top) env(safe-area-inset-right) 
  //          env(safe-area-inset-bottom) env(safe-area-inset-left);
  // height: 100%; 
  // min-height: -webkit-fill-available; /* 关键属性 */
 
}

.pro-qrcode-dialog {
  display: flex;
  width: 400px;
  min-height: 400px;
  //max-height: 703px;
  background-color: #FFFFFF;
  border-radius: 8px;
  flex-direction: column;
  position: relative;
  z-index: 1;
  overflow-y: auto;
  align-items: center;
  .icon-icon_close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 24px;
    height: 24px;
    color: #8C8C8C;
    cursor: pointer;
  }
  .pro-qrcode-dialog-title {
    font-size: 16px;
    font-weight: bold;
    color: #262626;
    margin-top: 40px;
  }
  .pro-qrcode-dialog-tips {
    font-size: 14px;
    color: #8C8C8C;
    margin-top: 10px;
    margin-bottom: 40px;
  }
  .pro-qrcode-dialog-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 37px;
    .pro-qrcode-dialog-pay-title {
      font-size: 24px;
      color: #E14C25;
    }
    .pro-qrcode-dialog-content-img {
      width: 24px;
      height: 24px;
    }
  }
  .qrcode-box {
    margin-top: 20px;
    .qrIcon {
      width: 200px;
      height: 200px;  
      opacity: 1;
      transform: scale(1.0);
    }
    .pro-qrcode-dialog-content-iframe{
      width: 200px;
      height: 200px;
      transform: translateZ(0); /* 启用硬件加速 */
      image-rendering: crisp-edges;
      -webkit-font-smoothing: antialiased;
      border: none; /* 移除默认边框 */;
    }
  }
}

</style>
